import { render } from "./VotesBlock.vue?vue&type=template&id=2f616166"
import script from "./VotesBlock.vue?vue&type=script&lang=js"
export * from "./VotesBlock.vue?vue&type=script&lang=js"
script.render = render

export default script